import { useState, useRef, useEffect } from 'react';
import type { User } from '../../../../packages/shared/src/types';
import { languages, useLanguage, setLanguage, languagePending, setLanguagePending, t } from '../lib/i18n';
import { api } from '../lib/api';
import type { AppLocale } from '../../../../packages/localization/src';
export function LanguageSelector({user}: {user:User|null}) {
  const {preference,pending}=useLanguage();
  const live=useRef(true),accountId=useRef(user?.id);accountId.current=user?.id;
  useEffect(()=>{live.current=true;return ()=>{live.current=false}},[]);
  const [busy,setBusy]=useState(false),[error,setError]=useState('');
  async function select(value:AppLocale|null) {
    if(languagePending())return;
    const owner=user?.id,previous=preference;
    setLanguagePending(true);
    setBusy(true);setError('');
    try {await setLanguage(value);if(user)await api('/api/privacy/language','POST',{expectedUserId:user.id,preferredLocale:value});}
    catch(e){if(live.current && accountId.current===owner){await setLanguage(previous);setError((e as Error).message)}}
    finally{setLanguagePending(false);if(live.current)setBusy(false)}
  }
  return <div className="language-settings"><label>{t('Language')}<select value={preference || ''} disabled={busy || pending} onChange={event=>void select((event.target.value||null) as AppLocale|null)}><option value="">{t('Follow device language')}</option>{languages.map(language=><option key={language.code} value={language.code} lang={language.code}>{language.name}</option>)}</select></label>{error&&<p role="alert">{error}</p>}</div>;
}
